import React, { useState } from 'react';
import Maps from '../screens/maps'
const Cotizaciones = () => {
  const [inicio, setInicio] = useState('');
  const [termino, setTermino] = useState('');

  const cotizar = async () => {
    const datos = {
  "inicio":"casa",
  "termino":"casa2",
  "mail":"joa.torresn@duocuc.cl"
};

    try {
      const response = await fetch('https://frabas.cl/backend/envios.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos),
      });

      const resultado = await response.json();
      if (resultado.success) {
        alert('Cotización enviada correctamente');
      } else {
        alert('Error al enviar la cotización');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Ocurrió un error al enviar la cotización');
    }
  };

  return (
    <div className="p-4 max-w-screen-lg mx-auto">
      
            <Maps />
        

      </div>
    
  );
};

export default Cotizaciones;
